import { Collapse, Color } from "capitalrx-components-2.0/lib/general";
import styled from "styled-components";

export const ThemedCollapse = styled(Collapse)`
  border: none !important;
    
  button {
    border: none;
    padding-left: 0;
    &:hover,
    &:focus {
      --title-color: ${Color.toString(Color.DarkGrey["500"])};
    }
    border-bottom: 1px solid ${Color.toString(Color.LightGrey["200"])} !important;
  }

  .content > .content-container {
    padding: 1rem 0 !important;
  }
`;
